<template>
<div>
  <div class="columns">
    <div class="column">
      <h5 class="title is-5 is-marginless">{{ scraper.name }}</h5>
      <p class="has-text-grey mb-1">{{ scraper.description }}</p>
      
      <div class="columns">
        <div class="column">
          <p class="has-text-weight-bold">Handler</p>
          <p class="has-text-grey">{{ scraper.scraper }}</p>
        </div>
      </div>
      
    </div>
  </div>
</div>  
</template>
<script>
export default {
  
  props: {
    scraper: {
      type: Object,
      default: () => ({})
    }
  }

}
</script>